import { jsx as _jsx } from "react/jsx-runtime";
import { useRef } from "react";
import classNames from "classnames";
import { useTrustPilot } from "../../hooks/useTrustPilot";
import { useConfig } from "../../providers/useConfig";
import styles from "./TrustPilotMicroReviewCount.module.scss";
export const TrustPilotMicroReviewCount = ({ className }) => {
    const { isEnabledForTenant, localeCode, businessUnitId, microReviewCountWidgetTemplateId, leaveAReviewLink } = useConfig();
    const ref = useRef(null);
    useTrustPilot({ ref });
    const isMisconfigured = !localeCode || !businessUnitId || !microReviewCountWidgetTemplateId || !leaveAReviewLink;
    if (!isEnabledForTenant || isMisconfigured) {
        return null;
    }
    return (_jsx("div", { ref: ref, "data-testid": "trustpilot-micro-review-count", className: classNames(styles.widget, className), "data-locale": localeCode, "data-template-id": microReviewCountWidgetTemplateId, "data-businessunit-id": businessUnitId, "data-style-height": "24px", "data-style-width": "100%", "data-theme": "light", "data-min-review-count": "0", "data-style-alignment": "center", children: _jsx("a", { href: leaveAReviewLink, target: "_blank", rel: "noopener noreferrer", children: "Trustpilot" }) }));
};
//# sourceMappingURL=TrustPilotMicroReviewCount.js.map